export default "__VITE_ASSET__C9e0NHPb__"